import { resourceQueryPredicates } from '../queries/resourceQueryPredicates.js';
import { isResourceDetailQueryKey, isResourceListQueryKey, isResourceAssetsQueryKey } from './queryKeyGuards.js';

const syncResourceDetailIntoResourceListQueries = (data, queryClient, resetStale = false) => {
  queryClient.setQueriesData({
    predicate: resourceQueryPredicates.resourceListAny,
    type: "active"
  }, (prevData) => {
    if (!prevData) return prevData;
    return {
      ...prevData,
      pages: prevData.pages.map((page) => ({
        ...page,
        resources: page.resources.map((resource) => {
          if (resource.id === data.id) {
            return {
              ...resource,
              ...data
            };
          }
          return resource;
        })
      }))
    };
  }, {
    updatedAt: resetStale ? Date.now() : void 0
  });
};
const syncFilterResourceQuery = (data, queryClient, resetStale = false) => {
  for (const page of data.pages) {
    for (const resource of page.resources) {
      queryClient.setQueriesData({
        predicate: (q) => resourceQueryPredicates.resourceDetail(q, resource.id),
        type: "active"
      }, (oldData) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          ...data
        };
      }, {
        updatedAt: resetStale ? Date.now() : void 0
      });
    }
  }
};
const syncResourceAssetsQuery = (data, queryClient) => {
  for (const resourceDetail of data.data.assets) {
    queryClient.setQueriesData({
      predicate: (q) => resourceQueryPredicates.resourceDetail(q, resourceDetail.id),
      type: "active"
    }, (oldData) => {
      if (!oldData) return oldData;
      return {
        ...oldData,
        ...resourceDetail
      };
    });
  }
};
const syncResourceQuery = (data, queryKey, queryClient, resetStale) => {
  if (!Array.isArray(queryKey) || queryKey.length === 0) return;
  if (isResourceDetailQueryKey(queryKey)) {
    syncResourceDetailIntoResourceListQueries(data, queryClient, resetStale);
  }
  if (isResourceListQueryKey(queryKey)) {
    syncFilterResourceQuery(data, queryClient, resetStale);
  }
  if (isResourceAssetsQueryKey(queryKey)) {
    syncResourceAssetsQuery(data, queryClient);
  }
};

export { syncResourceQuery };
//# sourceMappingURL=resourceSync.js.map
